import { createSheet } from 'flairup';

export const stylesheet = createSheet('epr');
